export const featureIds: {[featureLabel: string]: number } = {
    showSectionsGuidanceFlyout: 5601,
    vcardFirstPublish: 5110,
    EHInPristineCondition: 5760,
    businessCardShow: 5802,
    cipDisclaimer: 6117,
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/featureIds.ts
 **/